import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { SideBar } from '../shared/component/sidebar/siderbar';
import { RoomNoService } from '../service/room-no.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  getNowDateObject,
  getStreamNowDate
} from '../shared/tools/DateNowTime';
import { nowDate } from '../index/nowDate';
import { LanguageService } from '../service/language.service';

@Component({
  selector: 'app-hotel-info',
  templateUrl: './hotel-info.component.html',
  styleUrls: ['./hotel-info.component.scss']
})
export class HotelInfoComponent implements OnInit, OnDestroy, AfterViewInit {
  now_date = getStreamNowDate();
  sub: Subscription[] = [];
  now_date_obj: nowDate = getNowDateObject(
    new Date(),
    this.languageService.language
  );
  lang = '';

  focusIndex = 0;
  hotelIndex = 0;
  sidebar: SideBar<HotelInfoSideBarTiTleJpn, HotelInfoSideBarTiTleEng>[] = [
    {
      title: 'レストラン',
      title_jpn: 'レストラン',
      key_code: '1',
      title_eng: 'Restaurant',
      checked: true,
      focused: false
    },
    {
      title: 'ラウンジ',
      title_jpn: 'ラウンジ',
      key_code: '2',
      title_eng: 'Lounge',
      checked: false,
      focused: false
    },
    {
      title: 'コインランドリー',
      title_jpn: 'コインランドリー',
      key_code: '3',
      title_eng: 'Laundromat',
      checked: false,
      focused: false
    },
    {
      title: '喫煙所',
      title_jpn: '喫煙所',
      key_code: '4',
      title_eng: 'Smoking area',
      checked: false,
      focused: false
    },
    {
      title: '自動販売機・製氷機',
      title_jpn: '自動販売機・製氷機',
      key_code: '5',
      title_eng: 'Vending/Ice machine',
      checked: false,
      focused: false
    },
    {
      title: 'メニューへ戻る',
      title_jpn: 'メニューへ戻る',
      title_eng: 'Back to menu',
      key_code: '92',
      checked: false,
      focused: false
    }
  ];
  appname: string;

  machine: Machine[] = require('./machine.json');

  constructor(
    private roomNoService: RoomNoService,
    private router: Router,
    private languageService: LanguageService
  ) {}

  ngAfterViewInit() {
    (<any>document.querySelector('.tab_menu_li')).focus();
  }

  ngOnInit() {
    // 現在時刻の表示
    this.sub.push(
      this.now_date.subscribe(d => {
        this.now_date_obj = getNowDateObject(d, this.languageService.language);
      })
    );

    // Languageをサービスしちゃう
    this.lang = this.languageService.language;
    if (this.languageService.language === 'jpn') {
      this.appname = '館内施設';
      return;
    } else {
      this.appname = 'Facilities';
    }
    this.sidebar = this.sidebar.map(d => {
      d.title = d.title_eng;
      return d;
    });
    this.machine = this.machine.map(d => {
      return {
        name: d.name_en,
        name_jp: d.name_jp,
        name_en: d.name_en,
        icon_url: d.icon_url
      };
    });
  }
  ngOnDestroy() {
    this.sub.forEach(d => d.unsubscribe());
  }

  setFocusIndex(index: number) {
    //this.controlShow = true;
    this.focusIndex = index;
    this.sidebar.forEach(d => (d.checked = false));
    this.sidebar[this.focusIndex].checked = true;
    if (index != 5) {
      this.hotelIndex = index;
    }
  }

  setClickIndex(index: number) {
    //this.controlShow = true;
    if (index === 5) {
      this.router.navigate(['/room', this.roomNoService.room_no]);
    }
  }
}
type HotelInfoSideBarTiTleJpn =
  | 'レストラン'
  | 'ラウンジ'
  | 'コインランドリー'
  | '喫煙所'
  | '自動販売機・製氷機'
  | 'メニューへ戻る';

type HotelInfoSideBarTiTleEng =
  | 'Restaurant'
  | 'Lounge'
  | 'Laundromat'
  | 'Smoking area'
  | 'Vending/Ice machine';
